import * as React from 'react';
import * as styles from './Warning.css';
import { UIText2 } from '@cian/ui-kit';

interface IProps {
  message: string;
}

export const Warning = (props: IProps) => {
  const { message } = props;

  return (
    <div className={styles['wrapper']}>
      <UIText2 color="warning_100">{message}</UIText2>
    </div>
  );
};
